"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserImage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const md5_1 = __importDefault(require("md5"));
const react_1 = require("react");
const Image_1 = require("../Image");
function UserImage(_a) {
    var { userName } = _a, props = __rest(_a, ["userName"]);
    const hash = react_1.useMemo(() => md5_1.default(userName.trim().toLowerCase()), [userName]);
    return (jsx_runtime_1.jsx(Image_1.Image, Object.assign({ alt: `User avatar for ${userName}`, src: `https://www.gravatar.com/avatar/${hash}?s=80&d=mm` }, props), void 0));
}
exports.UserImage = UserImage;
//# sourceMappingURL=index.js.map